import React from 'react'

const NotPermitted: React.FunctionComponent = () => (
  <span style={{ textAlign: 'center', display: 'block', marginTop: 20 }}>Вы не можете просматривать эту странцу.</span>
)

export default NotPermitted
